import React, { useState, useEffect, useRef } from 'react'
import { useDebouncedEffect } from '@/utils/useDebouncedEffect'
import Pagination from '@/shared/Pagination'
import Loading from '@/shared/Loading'
import { useGlobalState } from '@/state'
import { EyeIcon } from '@heroicons/react/solid'
import useQuery from '@/hooks/useQuery'
import Card from '@/shared/Card'
import PublicSubmissionRow from '@/pages/Users/PublicProfile/PublicSubmissionRow'

const NoResults = () => {
  return (
    <span>
      <div className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cccblue" >
        <EyeIcon className="mx-auto h-12 w-12 text-gray-400" />
        <span className="mt-2 block text-sm font-medium text-gray-900 dark:text-gray-300">Nothing public here yet.</span>
      </div>
    </span>
  )
}

const PublicProfileSubmissions = () => {
  const [profileContainer, setProfileContainer] = useGlobalState('profileContainer')
  const [meta, setMeta] = useState({})
  const { getRequest } = useQuery()
  const { user, submissions, voteIds } = profileContainer
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [contains, setContains] = useState('')
  const scrollRef = useRef(null)

  useDebouncedEffect(() => { fetchData() }, 200, [contains])
  useEffect(() => { fetchData() }, [page])

  const fetchData = () => {
    setLoading(true)
    const data = {
      contains: contains,
      page: contains.length > 0 ? 1 : page
    }
    getRequest(`/api/v3/users/${user.username}/submissions`, data, (err, jsonData) => {
      setLoading(false)
      if (err) { /* hooks */ return }

      setProfileContainer({
        ...profileContainer,
        submissions: jsonData.submissions,
        voteIds: jsonData.voteIds
      })
      setMeta(jsonData.meta)
    })
  }

  return <>
    <Card light title='Submissions'>
      <>
        { user.auditionsCount > 0 && <div className='pb-3' ref={scrollRef}>
          <input name='contains' type="search" onChange={(e) => setContains(e.target.value)} placeholder="Search by project or role" aria-label='Search submissions' />
        </div> }
        { !loading && submissions.length === 0 && <NoResults /> }
        <ul className="space-y-3">
          {submissions.map((sub) => (
            <PublicSubmissionRow key={`pubsub${sub.id}`} submission={sub} voteIds={voteIds} />
          ))}
        </ul>
        { loading && <Loading /> }
        { submissions.length > 0 && <div className='mt-3'><Pagination meta={meta} callback={setPage} scrollRef={scrollRef} /></div> }
      </>
    </Card>
  </>
}

export default PublicProfileSubmissions
